import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
let UploadAddon = class UploadAddon extends Vue {
  dataChage(value) {
    this.zItem = value;
  }
};
__decorate([Prop({
  type: Number,
  default: {}
})], UploadAddon.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], UploadAddon.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
}), Prop({
  type: Object,
  default: {}
})], UploadAddon.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], UploadAddon.prototype, "dataChage", null);
UploadAddon = __decorate([Component({
  name: "uploadAddon",
  components: {
    PicUpload
  }
})], UploadAddon);
export default UploadAddon;